<div class="hero" *ngIf="!useRebranded">
  <div class="hero-overlay"></div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          <span class="fw-light">Welcome to identi</span><br />
        </h1>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4">
  <p class="fs-4 text-center">We are sorry, this pet is marked as passed away in our database</p>
</div>
